import router from "@/router";
import axios from "axios";
import global from "@/utils/global.js";
import { Message } from "element-ui";
import qs from "qs";
import Vue from "vue";
import deviceCode from "@/utils/deviceCode";

axios.defaults.withCredentials = false;
import { Loading } from "element-ui";

let thisLoadingCount = 0;
let loadingInstance;
const startLoading = () => {
  if (thisLoadingCount < 1) {
    loadingInstance = Loading.service({
      lock: true,
      background: "rgba(0, 0, 0, 0.1)",
      body: true,
    });
  }
  thisLoadingCount += 1;
};

const endLoading = () => {
  thisLoadingCount -= 1;
  if (thisLoadingCount <= 0) {
    loadingInstance.close();
    thisLoadingCount = 0;
  }
};

let service = axios.create();

service.interceptors.request.use(
  (config) => {
    if (config.timeout != 60000) {
      startLoading();
    }
    if (!localStorage.getItem("deviceCode")) {
      localStorage.setItem("deviceCode", deviceCode());
    }
    config.headers["deviceCode"] = localStorage.getItem("deviceCode");

    if (config.contentType) {
      config.headers["Content-Type"] = "application/json;charset=utf-8231";
    }

    config["redirect"] = false;
    const token = window.sessionStorage.getItem("ZCTOKEN");
    if (!token) config["redirect"] = true;
    config.headers["Authorization"] = token;
    if (!config.data) {
      config.data = {};
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
service.interceptors.response.use(
  (response) => {
    endLoading();

    //  if(thisLoadingCount){
    //   thisLoadingCount.close()

    //  }
    if (response.data.status) {
      if (response.data.status == 302 || response.data.status == 201) {
        window.sessionStorage.setItem("ZCTOKEN", "");
        window.sessionStorage.setItem("userInfo", "");
        router.push({
          name: "login",
          query: {
            redirect: "/login",
          },
        });
      } else if (response.data.status != 200) {
        Message.closeAll();
        Message({
          message: response.data.msg,
          type: "error",
          duration: 2 * 1000,
          offset: 30,
        });
        return Promise.reject();
      }
    }

    return response;
  },
  (error) => {
    endLoading();

    // if(thisLoadingCount){
    //   thisLoadingCount.close()

    //  }

    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = "请求错误";
          break;
        case 401:
          error.message = "未授权，请登录";
          break;
        case 403:
          error.message = "拒绝访问";
          break;
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`;
          if (error.response.config.redirect) {
            error.message = "无用户信息";

            router.push({
              name: "login",
            });
          }
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          error.message = "服务器内部错误";
          break;
        case 501:
          error.message = "服务未实现";
          break;
        case 502:
          error.message = "网关错误";
          break;
        case 503:
          error.message = "服务不可用";
          break;
        case 504:
          error.message = "网关超时";
          break;
        case 505:
          error.message = "HTTP版本不受支持";
          break;
        default:
          break;
      }
    }
    return Promise.reject(error);
  }
);

let psFromParam = function(params) {
  return qs.stringify(params, {
    arrayFormat: "indices",
    allowDots: true,
  });
};

/**
 * 请求工具
 * @param data 配置
 *         whetherFromParam 是否以参数形式请求 默认true
 *         whetherLoading   是否添加请求蒙版 默认true
 * @param callBack 回调
 */

let requestAxios = function(data, callBack, errorBack) {
  let axiosDefault = {
    baseURL: global.baseURL,
    timeout: 5000,
    withCredentials: true,
    whetherLoading: false,
    whetherFromParam: true,
    method: "post",
  };
  Object.assign(axiosDefault, data);
  console.log(axiosDefault);
  if (axiosDefault.whetherFromParam)
    axiosDefault.transformRequest = [psFromParam];
  service(axiosDefault)
    .then(function(data) {
      if (callBack && data && data.status == 200) {
        callBack(data.data);
      }
    })
    .catch(() => {
      if (errorBack) {
        errorBack();
      }
    });
};

let requestAxiosForm = function(data, callBack, errorBack) {
  let axiosDefault = {
    baseURL: global.baseURL,
    timeout: 5000,
    withCredentials: true,
    whetherLoading: false,
    whetherFromParam: true,
    contentType: true,

    method: "post",
  };
  Object.assign(axiosDefault, data);

  service(axiosDefault)
    .then(function(data) {
      if (callBack && data && data.status == 200) {
        callBack(data.data);
      }
    })
    .catch((e) => {
      if (errorBack) {
        errorBack();
      }
    });
};
//导出
function downloadAFile(data, Title) {
  let axiosDefault = {
    baseURL: global.baseURL,
    timeout: 5000,
    withCredentials: true,
    whetherLoading: false,
    whetherFromParam: true,
    method: "post",
    responseType: "blob",
  };
  Object.assign(axiosDefault, data);
  if (axiosDefault.whetherFromParam)
    axiosDefault.transformRequest = [psFromParam];
  service(axiosDefault)
    .then(function(data) {
      if (data && data.status == 200) {
        let fileName = "";
        if (data.headers && data.headers["content-disposition"]) {
          fileName = decodeURIComponent(
            data.headers["content-disposition"].split("=")[1]
          );
        }

        const link = document.createElement("a");
        let binaryData = [];
        binaryData.push(data.data);
        link.href = window.URL.createObjectURL(new Blob(binaryData));
        link.download = fileName || `${Title}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(link);
      } else {
        Message({
          message: data.msg,
          type: "error",
          duration: 2 * 1000,
          offset: 30,
        });
      }
    })
    .catch((err) => {});
}

function uploadFileAxios(data, callBack, errorBack) {
  // 默认配置
  let axiosDefault = {
    baseURL: global.baseURL,
    timeout: 5000,
    withCredentials: true,
    whetherLoading: false,
    whetherFromParam: true,
    method: "post",
    headers: {},
  };

  Object.assign(axiosDefault, data);
  axiosDefault["headers"]["Content-Type"] = "multipart/form-data;";
  service(axiosDefault)
    .then(function(data) {
      if (callBack) {
        callBack();
      }
    })
    .catch((err) => {
      if (errorBack) {
        errorBack();
      }
    });
}

Vue.prototype.$uploadFileAxios = uploadFileAxios;
Vue.prototype.$downloadAFile = downloadAFile;
Vue.prototype.$requestAxios = requestAxios;
Vue.prototype.$requestAxiosForm = requestAxiosForm;

export { requestAxiosForm, requestAxios };
